(function () {
  function initProduct(root) {
    if (!root || root.dataset.ferrerProductInit === "true") return;
    root.dataset.ferrerProductInit = "true";

    var form = root.querySelector("form[action*='/cart/add']");
    var variantInput = root.querySelector("[data-ferrer-variant-input]");
    var priceEl = root.querySelector("[data-ferrer-price]");
    var mainImage = root.querySelector(".gallery__main-image");
    var submitButton = form ? form.querySelector("[type='submit']") : null;
    
    // Fallback: Se o JSON quebrar, tenta habilitar o botão se houver variantes disponíveis
    if (variants.length === 0 && dataEl) {
      console.warn("Ferrer: JSON de variantes inválido ou vazio. Tentando recuperação...");
    }
    var stickyBar = root.querySelector("[data-ferrer-sticky-atc]");
    var stickyBtn = root.querySelector("[data-ferrer-sticky-submit]");
    var stickyPrice = root.querySelector("[data-ferrer-sticky-price]");
    var qtyInput = root.querySelector(".quantity-stepper__input");
    var qtyMinus = root.querySelector("[data-ferrer-qty-minus]");
    var qtyPlus = root.querySelector("[data-ferrer-qty-plus]");

    var variants = [];
    var dataEl = root.querySelector("[data-ferrer-variants]");
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        variants = [];
      }
    }

    function setMainImage(url) {
      if (!mainImage || !url) return;
      mainImage.src = url;
      mainImage.srcset = "";
      root.dispatchEvent(new CustomEvent("ferrer:gallery-image-changed", { detail: { url: url } }));
    }

    root.querySelectorAll("[data-ferrer-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var url = thumb.getAttribute("data-ferrer-image-url");
        setMainImage(url);
        root.querySelectorAll(".gallery__thumb").forEach(function (item) {
          item.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });

    function priceHtml(priceCents, compareCents, formattedPrice, formattedCompare) {
      if (compareCents && compareCents > priceCents) {
        var pct = Math.round(((compareCents - priceCents) * 100) / compareCents);
        return (
          '<span class="price price--on-sale">' +
          '<span class="price__compare">' + formattedCompare + "</span>" +
          '<span class="price__now">' + formattedPrice + "</span>" +
          '<span class="price__badge">-' + pct + "%</span>" +
          "</span>"
        );
      }
      return '<span class="price"><span class="price__now">' + formattedPrice + "</span></span>";
    }

    function selectedOptions() {
      var values = [];
      root.querySelectorAll(".variant-picker").forEach(function (fieldset) {
        var checked = fieldset.querySelector("input[type='radio']:checked");
        if (checked) values.push(checked.value);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (opts.length !== values.length) continue;
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (opts[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function setSubmitState(available) {
      if (!submitButton) return;
      submitButton.disabled = !available;
      submitButton.textContent = available
        ? submitButton.getAttribute("data-add-label") || "Adicionar à sacola"
        : submitButton.getAttribute("data-sold-out-label") || "Esgotado";

      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = submitButton.textContent;
      }
    }

    function renderPrice(variant) {
      if (!variant || !variant.price_formatted) return null;
      return priceHtml(
        variant.price,
        variant.compare_at_price,
        variant.price_formatted,
        variant.compare_at_formatted
      );
    }

    function syncVariant() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        setSubmitState(false);
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      var priceMarkup = renderPrice(variant);
      if (priceMarkup) {
        if (priceEl) priceEl.innerHTML = priceMarkup;
        if (stickyPrice) stickyPrice.innerHTML = priceMarkup;
      }

      if (variant.media_url) setMainImage(variant.media_url);

      setSubmitState(variant.available);
    }

    var optionInputs = root.querySelectorAll("[data-ferrer-variant-option]");

    if (submitButton) {
      submitButton.setAttribute("data-add-label", submitButton.textContent.trim());
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener("click", function () {
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, value - 1);
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener("click", function () {
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = value + 1;
      });
    }

    if (stickyBtn && form && submitButton) {
      stickyBtn.addEventListener("click", function () {
        if (!submitButton.disabled) submitButton.click();
      });
    }

    if (stickyBar && submitButton && window.IntersectionObserver) {
      var stickyMedia = window.matchMedia("(max-width: 55.99rem)");
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.hidden = entry.isIntersecting || !stickyMedia.matches;
          });
        },
        { threshold: 0, rootMargin: "0px 0px -1px 0px" }
      );

      function bindStickyObserver() {
        stickyObserver.disconnect();
        if (stickyMedia.matches) {
          stickyBar.hidden = true;
          stickyObserver.observe(submitButton);
        } else {
          stickyBar.hidden = true;
        }
      }

      bindStickyObserver();
      stickyMedia.addEventListener("change", bindStickyObserver);
    }

    if (optionInputs.length > 0) {
      optionInputs.forEach(function (option) {
        option.addEventListener("change", syncVariant);
      });
      syncVariant();
    }

    initZoom(root, mainImage);
  }

  function initZoom(root, img) {
    var wrap = root.querySelector("[data-ferrer-zoom-wrap]");
    var lens = root.querySelector("[data-ferrer-zoom-lens]");
    var pane = root.querySelector("[data-ferrer-zoom-pane]");
    var main = root.querySelector("[data-ferrer-gallery-main]");
    if (!wrap || !lens || !pane || !img || !main) return;
    if (!window.matchMedia("(pointer: fine) and (min-width: 48rem)").matches) return;

    var zoomLevel = 2.4;
    var active = false;

    function updateZoom(clientX, clientY) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      var y = Math.max(0, Math.min(clientY - rect.top, rect.height));
      var xp = (x / rect.width) * 100;
      var yp = (y / rect.height) * 100;
      var lensSize = Math.min(rect.width, rect.height) * 0.28;

      lens.hidden = false;
      pane.hidden = false;
      main.classList.add("is-zooming");

      lens.style.width = lensSize + "px";
      lens.style.height = lensSize + "px";
      lens.style.left = x - lensSize / 2 + "px";
      lens.style.top = y - lensSize / 2 + "px";

      pane.style.backgroundImage = "url(" + (img.currentSrc || img.src) + ")";
      pane.style.backgroundSize = rect.width * zoomLevel + "px " + rect.height * zoomLevel + "px";
      pane.style.backgroundPosition = xp + "% " + yp + "%";
    }

    function stopZoom() {
      active = false;
      lens.hidden = true;
      pane.hidden = true;
      main.classList.remove("is-zooming");
    }

    wrap.addEventListener("mouseenter", function () {
      active = true;
    });
    wrap.addEventListener("mouseleave", stopZoom);
    wrap.addEventListener("mousemove", function (event) {
      if (!active) return;
      updateZoom(event.clientX, event.clientY);
    });
    root.addEventListener("ferrer:gallery-image-changed", function () {
      if (active && !pane.hidden) {
        updateZoom(wrap.getBoundingClientRect().left + wrap.offsetWidth / 2, wrap.getBoundingClientRect().top + wrap.offsetHeight / 2);
      }
    });
  }

  function syncCartQtyInputs() {
    var desktop = window.matchMedia("(min-width: 56rem)").matches;
    document.querySelectorAll("[data-ferrer-cart-qty-mobile]").forEach(function (input) {
      input.disabled = desktop;
    });
    document.querySelectorAll("[data-ferrer-cart-qty-desktop]").forEach(function (input) {
      input.disabled = !desktop;
    });
  }

  function initCartQty() {
    syncCartQtyInputs();
    if (!window.__ferrerCartQtyMediaBound) {
      window.__ferrerCartQtyMediaBound = true;
      window.matchMedia("(min-width: 56rem)").addEventListener("change", syncCartQtyInputs);
    }

    document.querySelectorAll("[data-ferrer-cart-qty]").forEach(function (input) {
      if (input.dataset.ferrerCartQtyInit === "true") return;
      input.dataset.ferrerCartQtyInit = "true";
      input.addEventListener("change", function () {
        if (input.disabled) return;
        var form = input.closest("form");
        if (form) form.submit();
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-ferrer-product]").forEach(initProduct);
    initCartQty();
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
